import type { DefaultValues } from 'react-hook-form';

import type { AddClientContactInput, AttachClientContactInput } from '@/entities/client';

// `relationship` is undefined on purpose: no choice is a missing value, not an empty string, and the
// contract's own "Select relationship" message is what the form shows for it (FR-014). The key has
// to be present anyway — the Controller registers it as `undefined`, and a form whose defaults lack
// the key compares as dirty for good after the first edit, even once every edit is undone.
export const ADD_CLIENT_CONTACT_DEFAULTS = {
    firstName: '',
    lastName: '',
    emailPrimary: '',
    phonePrimary: '',
    address: { street1: '', street2: '', city: '', state: '', zip: '' },
    relationship: undefined,
    isEmergencyContact: false,
    isBillingContact: false,
    notes: '',
} satisfies DefaultValues<AddClientContactInput>;

// `personId` is filled in by the selection, and the person's own details by the same reset, so what
// is empty here is only what the therapist has not been shown yet. Relationship, both flags and
// notes always start empty (FR-015): they belong to this attachment, not to the person.
export const ATTACH_CLIENT_CONTACT_DEFAULTS = {
    personId: '',
    emailPrimary: '',
    phonePrimary: '',
    address: { street1: '', street2: '', city: '', state: '', zip: '' },
    relationship: undefined,
    isEmergencyContact: false,
    isBillingContact: false,
    notes: '',
} satisfies DefaultValues<AttachClientContactInput>;
